import type { FeatureFlags } from './config/featureFlags';
import type { LegacyPermissionKey } from './config/legacyPermissions';

export type MountMode = 'standalone' | 'embedded';

export interface MountConfig {
  mode: MountMode;
  initialPath?: string;
  featureFlagOverrides?: Partial<FeatureFlags>;
  permissionOverrides?: LegacyPermissionKey[];
}

let currentConfig: MountConfig = {
  mode: 'standalone',
  initialPath: '/Home/dashboard',
};

export function setMountConfig(config: MountConfig) {
  currentConfig = config;
}

export function getMountConfig() {
  return currentConfig;
}
